<template>
  <div class="mt-3">
    <label>{{ label }}</label>
    <div
      :class="[isValidate ? 'border-error input-container' : 'input-container']"
    >
      <datetime
        type="date"
        class="date-picker"
        :input-style="styleDatetime"
        v-model="date"
        placeholder="DD/MM/YYYY"
        format="dd/MM/yyyy"
        value-zone="Asia/Bangkok"
        ref="dateField"
      >
      </datetime>
      <div
        :class="'icon-container text-right'"
        @click="$refs.dateField.isOpen = true"
      >
        <font-awesome-icon
          icon="calendar-alt"
          :class="'pointer'"
          :color="$store.state.theme.themePrimaryColor"
        />
      </div>
    </div>
    <div v-if="isValidate" class="text-error ft-14 mt-1">กรุณากรอกข้อมูล</div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      required: true,
      type: String
    },
    isValidate: {
      required: false,
      type: Boolean
    },
    fieldtype: {
      required: true,
      type: Number
    },
    questionId: {
      required: true,
      type: Number
    },
    value: {
      required: false,
      type: String
    }
  },
  watch: {
    date() {
      this.$emit("handleDate", {
        answer_id: 0,
        answer: this.date,
        type: this.fieldtype,
        questionId: this.questionId
      });
    }
  },
  data() {
    return {
      date: this.value,
      styleDatetime: {
        width: "100%",
        border: "none"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  padding: 5px 10px;
  border: 1px solid #d8dbe0;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
}
.icon-container {
  flex: 1 1 auto;
  cursor: text;
}
.text-error {
  color: red;
}
.ft-14 {
  font-size: var(--text-md);
}
.border-error {
  border-color: red;
}
</style>
